export default function LogsTable({ logs, currentPage, itemsPerPage, handleDownload }) {

    // índice base para numeración
    const startIndex = (currentPage - 1) * itemsPerPage;

    return (
        <table className="table">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Archivo</th>
                    <th>Tipo</th>
                    <th>Acción</th>
                </tr>
            </thead>
            <tbody className="table-group-divider">
                {logs.length > 0 ? (
                    logs.map((log, index) => {
                        // Extraer tipo
                        let type = 'info';
                        if (log.includes('error')) type = 'error';
                        else if (log.includes('warn')) type = 'warn';
                        // Color según tipo
                        const badgeClass =
                            type === 'error'
                                ? 'bg-danger'
                                : type === 'warn'
                                ? 'bg-warning text-dark'
                                : 'bg-success';
                        return (
                            <tr key={log}>
                                <td>{startIndex + index + 1}</td>
                                <td>{log}</td>
                                <td>
                                    <span className={`badge ${badgeClass}`}>
                                        {type.toUpperCase()}
                                    </span>
                                </td>
                                <td>
                                    <button className="btn btn-primary btn-sm" onClick={() => handleDownload(log)}>Descargar</button>
                                </td>
                            </tr>
                        );
                    })
                ) : (
                    <tr>
                        <td colSpan="4" className="text-center">
                            No hay logs disponibles
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
}